module.exports = __webpack_public_path__ + "static/media/crossing_photo.6553b65d.png";